// extracted by mini-css-extract-plugin
module.exports = {"tabs":"_4bbd2dc","group":"_5699d69","groupInformation":"_af65cd4","event":"_71f04b0","eventInformation":"_160cd8b"};